// extracted by mini-css-extract-plugin
export default {"loader__container":"loader_loader__container__ucQXN"};